import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0 15px;
  gap: 15px;
`

export const Item = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
`

export const TextWrapper = styled.div`
  width: 100%;

  .subtitle {
    color: #898989;
    line-height: 16px;
  }

  .exception {
    font-size: 12px;
  }

  span {
    font-weight: normal;
  }
`

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Link = styled.a`
  font-weight: bold;
  margin-right: 10px;
  
  &:hover {
    color: #3650E5;
  }
`